















































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Modal extends Vue {
  private openBtn!: HTMLElement;

  private closeBtn!: HTMLElement;

  @Prop({ default: 'Cancelar' })
  private cancelButton!: string | boolean;

  @Prop({ default: 'Enviar' })
  private sendButton!: string;

  @Prop({ default: 'Modal' })
  public header!: string;

  @Prop({ default: Math.random().toString(36).substring(2, 6).toUpperCase() })
  public name!: string;

  public open() {
    this.openBtn.click();
  }

  public close() {
    this.closeBtn.click();
  }

  private mounted() {
    this.openBtn = this.$refs.open as HTMLElement;
    this.closeBtn = this.$refs.close as HTMLElement;
  }

  private confirm() {
    this.$emit('confirm');
  }

  private cancel(triggerAction: boolean = false) {
    this.$emit('cancel', triggerAction);
  }
}
